const suffix = process.env.NEXT_PUBLIC_ZONE_SUFFIX ? process.env.NEXT_PUBLIC_ZONE_SUFFIX.substr(1) : ''
const API_URL = suffix ? `https://${suffix}/admin/api` : 'http://dev.local:4006/admin/api'
const IMG_URL = suffix ? `https://${suffix}` : 'http://dev.local:4006'

module.exports = {
  API_URL,
  IMG_URL,
}
